import React from "react";
import { useLocation } from "react-router-dom";
import { Link } from "../ui/Link";
import {
    ReciepeText,
    ClipboardText,
    UserEdit,
    DrohneIcon,
} from "../Icons";
import Store from "../../store/Store";

const providerNavigationItems = [
    {
        label: "Aufträge",
        href: "/orders",
        icon: <ClipboardText />,
    },
    {
        label: "Zahlungen",
        href: "/money",
        icon: <ReciepeText />,
    },
    {
        label: "Benutzer",
        href: "/users",
        icon: <UserEdit />,
    },
    {
        label: "Flotte",
        href: "/flottenmanagement",
        icon: <DrohneIcon />,
    },
];

const fleetPaths = ['/flottenmanagement', '/drohnenstationen', '/flaechen'];

function ProviderHeaderNavigation() {
    const location = useLocation();
    const user = Store.user;
    const isAdmin = user?.roles?.some(
        (r) => r.name === 'ROLE_ADMIN' || r.name === 'ROLE_SUPER_ADMIN'
    );
    return (
        <div className="w-full">
            <nav className="mx-auto flex max-w-5xl items-center justify-center gap-10 px-6">
                {providerNavigationItems
                    .filter(item => item.label !== 'Benutzer' || isAdmin)
                    .map(({ label, href, icon: Icon }) => {
                        const isActive =
                            label === 'Flotte'
                                ? fleetPaths.includes(location.pathname)
                                : location.pathname === href || location.pathname.startsWith(href + "/");
                        return (
                            <div
                                key={label}
                                className={
                                    "flex justify-center px-5 py-4 transition rounded-[100px] " +
                                    (isActive
                                        ? "bg-white shadow"
                                        : "bg-transparent")
                                }
                            >
                                <Link
                                    aria-label={label}
                                    to={href}
                                    data-pw={`button-provider-header-${label.toLowerCase()}`}
                                    className="gap-2 group flex items-center text-base font-semibold text-[#333] w-full justify-center"
                                >
                                    {Icon}
                                    <span className="relative group-hover:underline">
                                        {label}
                                    </span>
                                </Link>
                            </div>
                        );
                    })}
            </nav>
        </div>
    );
}

export default ProviderHeaderNavigation;
